/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Agents combine instructions, tools and knowledge spaces to handle recurring work on their own." |
*
* @param {Agent_Builder_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_empty_description = /** @type {((inputs?: Agent_Builder_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agenten verbinden Anweisungen, Tools und Wissensbereiche, um wiederkehrende Aufgaben selbstständig zu erledigen.")
	return /** @type {LocalizedString} */ ("Agents combine instructions, tools and knowledge spaces to handle recurring work on their own.")
});